import DefaultBannerImagePNG from '../assets/images/default_banner_image.png';
import SpecialLogoPNG from '../assets/images/special_logo.png';
import SymbolAndTypoDarkPNG from '../assets/images/symbol_and_typo_dark.png';
import SymbolAndTypoLightPNG from '../assets/images/symbol_and_typo_light.png';

export const DEFAULT_USER_PROFILE_IMAGE_URL =
  'https://image.zeta-ai.io/user-profile-image/default-profile.png';
export const DEFAULT_CHARACTER_PROFILE_IMAGE_URL =
  'https://image.zeta-ai.io/profile-image/default-profile.png';
export const DEFAULT_BANNER_IMAGE_URL = DefaultBannerImagePNG;
export const SYMBOL_AND_TYPO_DARK_IMAGE_URL = SymbolAndTypoDarkPNG;
export const SYMBOL_AND_TYPO_LIGHT_IMAGE_URL = SymbolAndTypoLightPNG;
export const SPECIAL_LOGO_IMAGE_URL = SpecialLogoPNG;
